import React, { ReactElement } from 'react';
import { render } from 'react-dom';

import { BaseDialog } from './baseDialog';
import { Button } from './button';
import { H1 } from './headings';
import { Modal } from './modal';
import { ModalContents } from './modalContents';

export class Confirm extends BaseDialog<boolean> {
  value = '';

  constructor(message: ReactElement | string, okText = 'OK', rejectText = 'Cancel', headerText = 'Confirm', confirmButtonProps?: Record<string, string>, cancelButtonProps?: Record<string, string>) {
    super();
    this.el = document.createElement('div');
    this.el.id = 'confirm';

    document.body.appendChild(this.el);

    render(
      <Modal className="hdn-modal" isOpen onToggle={this.close} dialog data-test="confirm" contentLabel="Confirm dialog">
        <ModalContents>
          <form onSubmit={this.confirm}>
            <H1 mbSize="xl">{headerText}</H1>
            <p>{message}</p>
            <div className="hdn-modal__footer">
              <Button onClick={this.close} variant="secondary" {...cancelButtonProps}>
                {rejectText}
              </Button>
              <Button onClick={this.confirm} {...confirmButtonProps}>{okText}</Button>
            </div>
          </form>
        </ModalContents>
      </Modal>,
      this.el,
    );
  }
}
